import styles from './CreationActionsPanel.module.scss';
import type { CharacterCreationDraft } from '../../hooks';
import { Button } from '@sorrem-client/ui/components';

interface CreationActionsPanelProps {
    draft: CharacterCreationDraft;
}

export function CreationActionsPanel({ draft }: CreationActionsPanelProps): JSX.Element {
    return (
        <div className={styles.actionsBar}>
            <div className={styles.actions}>
                {draft.hasExistingCharacters && (
                    <Button variant="secondary" onClick={draft.onCancel} disabled={draft.isSaving}>
                        Cancel
                    </Button>
                )}
                <Button
                    onClick={draft.onCreate}
                    disabled={!draft.canSubmit}
                >
                    {draft.isSaving ? 'Creating...' : 'Create'}
                </Button>
            </div>
        </div>
    );
}
